import React from 'react';
import { Link, Redirect } from 'react-router-dom';

class Footer extends React.Component {
  
  state = {
    redirect: false
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect : false
    };
  }

  goTo = () =>{
    setTimeout(() => {
      let contactElement = document.getElementById("contact");
      contactElement.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 100);
  }

  moveToContactForm(e){
    e.preventDefault()
    let userLocation = window.location.href.split('/');
    let userLocation2 = userLocation[3];
    if(userLocation2 === 'clientes' || userLocation2 === 'aliados' || userLocation2 === '' ){
      this.goTo();
    }else{
      this.setState({ redirect: true },
        ()=>this.goTo());
    }
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {

    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to='/'/>;
    }

    return (
      <React.Fragment>
        <footer className="footer-section">
          <div
            className={"footer-top background-img-2 " + (this.props.noSubscription ? 'py-5' : 'pt-150 pb-5')} 
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/img/footer-bg.png)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center top",
              backgroundSize: "cover"
            }}
          >
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-lg-3 mb-3 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <img
                      src={`${process.env.PUBLIC_URL}/img/logo-white.png`}
                      alt="footer logo"
                      width="120"
                      className="img-fluid mb-3"
                    />
                    <p>
                      Entregamos el producto justo, en el momento correcto.
                      Trabajamos con las mejores marcas, las apoyamos y crecemos juntos construyendo tu asistente de compras virtual.
                      Nuestra pasión es poder llevarte eso que quieres, en el momento justo y en el lugar que elijas.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 ml-auto mb-4 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Compañía</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <a href="/sobre-nosotros">Sobre Nosotros</a>
                      </li>
                      <li className="mb-2">
                        <a onClick={ (e) => this.moveToContactForm(e)} href="#">Contáctanos</a>
                      </li>
                      <li className="mb-2">
                        <Link to="/equipo-frisbee">Únete a Nuestro Equipo</Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/terminos-de-privacidad">Privacidad</Link>
                      </li>
                      <li className="mb-2">
                        <a href="/terminos-y-condiciones">Términos y Condiciones</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 ml-auto mb-4 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Encuéntranos</h5>
                    <ul className="list-unstyled support-list">
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-location-pin mr-2"></span>
                        Quito
                        <br />
                        Ecuador
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-mobile mr-2"></span>{" "}
                        <a href="tel:+61283766284"> 1800-444-999</a>
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-email mr-2"></span>
                        <a href="mailto:mail@example.com"> contacto@frisbee.com.ec</a>
                      </li>
                      <li className="mb-2 d-flex align-items-center">
                        <span className="ti-world mr-2"></span>
                        <a href="/#"> www.frisbee.com.ec</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Redes Sociales</h5>
                    <div className="social-list-wrap">
                      <ul className="social-list list-inline list-unstyled">
                        <li className="list-inline-item">
                          <a href="https://www.facebook.com/Frisbee-112174453919592/" target="_blank" title="Facebook">
                            <span className="ti-facebook"></span>
                          </a>
                        </li>
                        {/* <li className="list-inline-item">
                          <a href="/#" target="_blank" title="Twitter">
                            <span className="ti-twitter"></span>
                          </a>
                        </li> */}
                        <li className="list-inline-item">
                          <a href="https://www.instagram.com/frisbee.ec/" target="_blank" title="Instagram">
                            <span className="ti-instagram"></span>
                          </a>
                        </li>
                        {/* <li className="list-inline-item">
                          <a href="/#" target="_blank" title="printerst">
                            <span className="ti-pinterest"></span>
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom gray-light-bg pt-4 pb-4">
            <div className="container">
              <div className="row text-center justify-content-center">
                <div className="col-md-6 col-lg-5">
                  <p className="copyright-text pb-0 mb-0">
                    Copyrights © 2020. Todos los derechos reservados
                    <a href="/#"> Frisbee</a>
                  </p>
                  <p className="copyright-text pb-0 mb-0">
                    Frisbee es parte de Epsilon Technology SCC
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
